import React, { useState } from "react";
import { TimePicker, renderTimeViewClock } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const MyTimePicker = ({
  value,
  fullWidth = true,
  disabled = false,
  size = "small",
  onChange,
  required = false,
  label = "Select Time",
  ...otherProps
}) => {
  // If value is not provided, manage the state internally.
  const [internalValue, setInternalValue] = useState(null);
  const validValue = dayjs(value).isValid() ? dayjs(value) : null;

  const handleChange = (newValue) => {
    // If an onChange function is provided, use it; otherwise, update the internal state.
    if (onChange) {
      onChange(newValue);
    } else {
      setInternalValue(newValue);
    }
  };

  return (
    <TimePicker
      disabled={disabled}
      slotProps={{
        textField: {
          fullWidth: fullWidth,
          size: size,
          required: required,
        },
      }}
      viewRenderers={{
        hours: renderTimeViewClock,
        minutes: renderTimeViewClock,
      }}
      label={label}
      value={validValue ? validValue : internalValue}
      onChange={handleChange}
      {...otherProps}
    />
  );
};

export default MyTimePicker;
